import { createStore } from 'vuex'
import { user, UserState } from './modules/user'
import { app, APPState } from './modules/app'
import { temp, TempState } from './modules/temp'
import createPersistedState from 'vuex-persistedstate'
export type RootState = {
  user: UserState
  app: APPState
  temp: TempState
}

const store = createStore({
  modules: {
    user,
    app,
    temp
  },
  plugins: [createPersistedState()]
})

export default store
